import React from 'react'
import { BuilderComponent } from '@builder.io/react'

import Hub from 'base/hub'
import bootstrappedData from 'base/lib/singletons/bootstrapped_data'
import ManualLinkRouter from 'mobile/manual_link_router'
import { isBuilderEditing } from 'base/lib/builder_helpers'
import useBuilderContent from 'base/react/hooks/useBuilderContent'
import LoadingAnimation from 'base/react/components/loading_animation'

export default function ({
  entry,
  model,
  children,
  customLoadingAnimation,
  userAttributes = {},
  ...props
}) {
  const { builderContent, error, isFetching } = useBuilderContent(model, userAttributes)

  const builderProps = {
    ...props,
    data: { ...props.data, Hub },
    content: builderContent,
    entry,
    model,
  }

  if (entry) {
    // if we have the builder content id/key (entry) remove builderProps.content or else it will
    //  attempt to render that content, even if null or undefined
    delete builderProps.content
  }

  if (isBuilderEditing) {
    // if we're editing in builder, delete entry or else it will attempt to render the entry
    // content instead of the previewed content
    delete builderProps.entry
  }

  // For a custom loading animation, a component can be passed down in the customLoadingAnimation attribute
  if (isFetching && !error) {
    return customLoadingAnimation ? customLoadingAnimation : <LoadingAnimation />
  }

  if (builderContent || entry) {
    return bootstrappedData.isOnReactRouter ? (
      <ManualLinkRouter>
        <BuilderComponent {...builderProps} />
      </ManualLinkRouter>
    ) : (
      <BuilderComponent {...builderProps} />
    )
  } else {
    props.onNoContent?.()
  }

  if (children) return children

  return null
}
